import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import Alert from 'components/new_ui/Alerts/alert';

import {
  Formik,
  Form as FormikForm,
} from 'formik';

import * as Yup from 'yup';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';

export default function Form({ addMember, teams }) {
  const formSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
    team: Yup.string().typeError('Please, select a Team'),
  });

  const onSubmitHundler = (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    if (addMember(values)) {
      resetForm();
    } else {
      Alert({
        title: 'Add Member',
        text: 'A member with this email address has already been added to the list.',
        confirmButtonText: 'Close',
      });
    }
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        firstName: '', lastName: '', email: '', team: null,
      }}
      onSubmit={onSubmitHundler}
    >
      <FormikForm className="needs-validation" noValidate="">
        <HorizontalTextField name="firstName" label="First Name" placeholder="First Name" required />
        <HorizontalTextField name="lastName" label="Last Name" placeholder="Last Name" required />
        <HorizontalTextField name="email" type="email" label="Email" placeholder="Email" required />
        <HorizontalSelectField name="team" label="Team" options={teams} required />
        <div className="text-end">
          Don’t have any?
          {' '}
          <a href={routes.managers.teams.index}>Create team</a>
        </div>

        <div className="mt-4 text-end">
          <Button
            type="submit"
          >
            Add To Member List
          </Button>
        </div>
      </FormikForm>
    </Formik>
  );
}

Form.propTypes = {
  addMember: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(PropTypes.object),
};

Form.defaultProps = {
  teams: [],
};
